<script>
    export default {
        name: "ProductFeaturesList",
        props: {
            features: Array,
        },
        methods: {
            scrollToAnchor() {
                setTimeout(() => {
                    document
                        .querySelector(".js-anchor-parameters")
                        .scrollIntoView({ block: "start", behavior: "smooth" });
                }, 150);

                this.$emit("on-scroll-to-anchor");
            },
        },
    };
</script>

<template>
    <div class="product-features-list">
        <div class="product-features-list__title">Особенности</div>
        <ul class="product-features-list__list">
            <li class="product-features-list__item" v-for="(feature, i) in features" :key="i">
                {{ feature }}
            </li>
        </ul>
        <button class="product-features-list__button outline" @click="scrollToAnchor">
            Смотреть все характеристики
        </button>
    </div>
</template>

<style lang="scss">
    .product-features-list__title {
        font-weight: bold;
        line-height: 26px;
        margin-bottom: 8px;
    }

    .product-features-list__list {
        list-style: none;
    }

    .product-features-list__item {
        position: relative;
        font-size: 14px;
        line-height: 22px;

        padding-left: 10px;

        &:after {
            content: "";
            position: absolute;
            left: 0;
            top: 9px;
            @include box(4px);
            border-radius: 50%;
            background-color: var(--dot-list-style);
        }

        &:not(:first-child) {
            margin-top: 8px;
        }
    }

    .product-features-list__button {
        margin-top: 16px;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        color: var(--info-text--dark);
        cursor: pointer;
        transition: 0.3s ease-in-out color;

        &:hover {
            color: var(--product-features-list-button--hover);
        }
    }
</style>
